export enum ActionName {
    CreateBlock = 'CreateBlock',
    CreateCompositionBlock = 'CreateCompositionBlock',
    CreateQuestionBlock = 'CreateQuestionBlock',
    CreateInvoiceBlock = 'CreateInvoiceBlock',
    CreatePackagesItemsBlock = 'CreatePackagesItemsBlock',
    DuplicateBlock = 'DuplicateBlock',
    UpdateBlockData = 'UpdateBlockData',
    UpdateBlockColumns = 'UpdateBlockColumns',
    ReplaceBlock = 'ReplaceBlock',
    UpdateVariableData = 'UpdateVariableData',
    UpdateMultipleBlocks = 'UpdateMultipleBlocks',
    MoveBlock = 'MoveBlock',
    DeleteBlock = 'DeleteBlock',
    UpdateBlockToTemplate = 'UpdateBlockToTemplate',
    ImportBlock = 'ImportBlock',
    CreateBlankInvoice = 'CreateBlankInvoice',
    ToggleInvoiceType = 'ToggleInvoiceType',
    CreateCreatePageAndBlock = 'CreateCreatePageAndBlock',
    CreatePage = 'CreatePage',
    DuplicatePage = 'DuplicatePage',
    ImportPages = 'ImportPages',
    UpdatePage = 'UpdatePage',
    DeletePage = 'DeletePage',
    UpdateFlow = 'UpdateFlow',
    UpdateFlowContent = 'UpdateFlowContent',
    PasteBlock = 'PasteBlock',
    UpdateServiceBlockFromAutocomplete = 'UpdateServiceBlockFromAutocomplete',
    UpdateServiceBlockFromTemplateSelection = 'UpdateServiceBlockFromTemplateSelection',
    UpdateServiceBlockColumns = 'UpdateServiceBlockColumns',
    ToggleDigitalProduct = 'ToggleDigitalProduct'
}
